import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {Row, Col} from "reactstrap";
import Carousel from "nuka-carousel";
import { BASE_URL } from "../../../../Config/axiosInstance";

export default function NewlyAdded() {

  const [displayWidth, setDisplayWidth] = React.useState(0);
  const { newlyAddedStores, } = useSelector((state) => state.Stores);

  React.useEffect(()=>{
    setDisplayWidth(window.innerWidth)
  })

  return(
    <>
    <div className="carousel pt-0 pb-2" id="recommended-res-4" style={{width:"100%", background: "#F3F4F6"}}>
    <div style={{display: "flex", justifyContent:"center", allignItems:"center"}}>
      <div style={{display:"flex", alignItems:"center", width:"250px",
       justifyContent:'center', fontSize:"16px", borderRadius:"5px  5px 34px 34px",
        background:"#374158", color:"#F9FAFB", marginBottom:"5px", height:"19px" , fontWeight:"600", paddingBottom:"2px"}}>
        <p style={{width:'200px', height:"23px",
        background:"#37415f", display:"flex", justifyContent:"center", alignItems:"center", borderRadius:"35px 35px 0 0"}}>
          {"latest stores".toUpperCase()}</p>
          </div>
          </div>
        <Carousel>   
    <Row>
      {newlyAddedStores.slice(0, displayWidth < 769 ? 3 : 6).map((store, i)=>{
        return(
        <Col id="brands-index2" style={{
                                padding:"0",}} >
            <Link to={`/store/${store.slug}`} style={{padding: "0", margin: "0"}}>
  <div id="na-card-i4" className="card shadow-sm">
    <img
      src={`${BASE_URL}/${store?.image}`}
      alt=""
      id="card-img-top-i4-na"
      className="card-img-top"
      style={{width:"100%", height:"100px"}}
      loading="lazy"
    />
    <div className="text-center my-4" id="na-card-i4-title" style={{fontWeight:"700"}}>
            {store?.slug.toUpperCase()}
            </div>
</div>
                      </Link>

        </Col>

          )
      })}
      </Row> 
    <Row>
      {newlyAddedStores.slice(displayWidth < 769 ? 3 : 6, displayWidth < 769 ? 6 : 12).map((store, i)=>{
        return(
        <Col id="brands-index2" style={{
                                padding:"0",}} >
            <Link to={`/store/${store.slug}`} style={{padding: "0", margin: "0"}}>
  <div  id="na-card-i4" className="card shadow-sm">
    <img
      src={`${BASE_URL}/${store?.image}`}
      alt=""
      id="card-img-top-i4-na"
      className="card-img-top"
      loading="lazy"
      style={{width:"100%", height:"120px"}}
    />
    <div className="text-center my-4"  id="na-card-i4-title" style={{fontWeight:"700"}}>
            {store?.slug.toUpperCase()}
            </div>
</div>
                      </Link>

        </Col>

          )
      })}
      </Row> 
    <Row>
      { newlyAddedStores.slice(displayWidth < 769 ? 6 : 12, displayWidth < 769 ? 9 : 18).map((store, i)=>{
        return(
        <Col id="brands-index2" style={{
                                padding:"0",}} >
            <Link to={`/store/${store.slug}`} style={{padding: "0", margin: "0"}}>
  <div id="na-card-i4" className="card shadow-sm">
    <img
      src={`h${BASE_URL}/${store?.image}`}
      alt=""
      id="card-img-top-i4-na"
      className="card-img-top"
      loading="lazy"
      style={{width:"100%", height:"120px"}}
    />
    <div className="text-center my-4"  id="na-card-i4-title" style={{fontWeight:"700"}}>
            {store?.slug.toUpperCase()}
            </div>
</div>
                      </Link>

        </Col>

          )
      })}
    </Row> 
  </Carousel>
  </div>
  </>
  )
}